export const KNOT_TO_KMH = 1.852;
export const UNKNOWN_DIRECTION = 999;
export const SPEED_SCALE = 0.00001; // 1px pour 1km
export const HOURS_12_IN_SEC = 3600 * 12;

export const getDate = (hours, minutes, seconds) => {
        const tmp = new Date();
        tmp.setUTCHours(hours, minutes, seconds);
     
        return tmp.toISOString();
    }